

import config from '@/config'
import banner from '@/assets/survey/bg1.png'
import axios from 'axios'
import Qs from 'qs'
import { getSurveyList } from '@/api/youzheng'
export default {
name: 'question',
components: {

},
data () {
return {
baseUrl:config.baseUrl,
banner: banner,
list: [],
listAll: [],
listDom: null,
moreshow: true,
suTitle:''
}
},
created () {










this.getList()
},
computed: {
},
mounted () {
this.listDom = this.$el.querySelector('.paper .cont>ul')
setTimeout(() => {
this.listDom.addEventListener('scroll', this.handleScroll)
}, 400)
},
methods:{
getList(){
getSurveyList({
activityid: this.$route.params.type
}).then(res => {
this.listAll = res.returnValue.PAPERLIST
this.suTitle = res.returnValue.TITLE
this.listAll.forEach( (item,i) => {
if(i <5 ){
this.list.push(item)
}
})
})
},
handleScroll () {
if (
this.listDom.scrollTop + this.listDom.clientHeight >=
this.listDom.scrollHeight
) {
this.moreshow = false
}
else{
this.moreshow = true
}
},
goto(id,isok){
if(isok != 1){
this.$vux.toast.text("问卷已过期！", 'middle');
}
else{
this.$router.push({ name: 'yzQuestionAsk', params: { type:id,activityid: this.$route.params.type } })
}
}
}
}
